import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/en.json';
import translationAR from './locales/ar.json';
import translationIW from './locales/he.json';


const savedLang = localStorage.getItem('traffic_lang') || 'ar';

const resources = {
  en: { translation: translationEN },
  ar: { translation: translationAR },
  he: { translation: translationIW },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLang,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

export default i18n;
